import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Grid, Button, Typography } from '@material-ui/core'

import ContainerWithTitle from '../../HOC/ContainerWithTitle'
import {
  fetchEmployees,
  getTimeCardList,
  clockOut,
  searchEmployees,
} from '../../../actions/employee'
import { getCompanyFeatures, getCompany } from '../../../actions/company'
import ListContainer from '../../../components/common/ListContainer'
import { hasAccess } from '../../../utils/api'
import { Appcues } from '../../../utils/constants'
import { canAddEmployee } from '../../../utils/api'
import { sortArrayByName } from '../../../utils/array'

class Employees extends PureComponent {
  state = {
    showClockedIn: false,
    term: '',
  }

  componentDidMount() {
    let loc = this.props.location.pathname.split('/')
    if (loc[loc.length - 1] === 'clocked_in') {
      this.setState({ showClockedIn: true })
    }
    this.props.dispatch(fetchEmployees())
    this.props.dispatch(getCompany())
    this.props.dispatch(getCompanyFeatures())
    this.props.dispatch(getTimeCardList())
  }

  viewEmployee = (id) => {
    this.props.history.push(`/settings/manage/employees/${id}/edit`)
  }

  onChangeTerm = (e) => {
    this.setState({ term: e.target.value })
  }

  clockOut = (id) => {
    Appcues.track('Employee clocked out')
    this.props.dispatch(clockOut(id)).then((res) => this.props.dispatch(getTimeCardList()))
  }

  onSearch = (value) => {
    // console.log(value, "term")
    this.props.dispatch(searchEmployees(value))
  }

  addEmployee = () => {
    Appcues.track('Adding Employee')
    this.props.history.push('/settings/manage/employees/add')
  }

  render() {
    const { employeeReducer = {}, companyReducer } = this.props
    const { employees = [], timecards = [] } = employeeReducer || {}
    const { companyFeatures = {} } = companyReducer || {}
    const { maxEmployees = 0 } = companyFeatures
    const timecardsInfo =
      (timecards &&
        timecards.length > 0 &&
        timecards.map((card) => ({
          name: `${card.employee.firstName} ${card.employee.lastName}`,
          clockInTime: new Date(card.timeCard.clockInTime).toLocaleString(),
          id: card.timeCard.id,
          timestampClockInTime: card.timeCard && card.timeCard.clockInTime,
        }))) ||
      []
    const employeeInfoSort = sortArrayByName(employees || [])
    const employeeInfo =
      employeeInfoSort &&
      employeeInfoSort.length > 0 &&
      employeeInfoSort.map((emp) => ({
        ...emp,
        empId: (emp.id && emp.id.length && emp.id.substr(emp.id.length - 5)) || '',
        roleName: (emp.role && emp.role.name) || '',
        status: emp.disabled ? 'Inactive' : 'Active',
        clockInTime: emp.timeCard ? new Date(emp.timeCard.clockInTime).toLocaleString() : '',
        timestampClockInTime: emp.timeCard && emp.timeCard.clockInTime,
      }))
    let timeCardColumns = [
      { id: 'name', label: 'Employee' },
      { id: 'clockInTime', label: 'Clocked In Time' },
      { id: 'action', label: '' },
    ]
    let employeeColumns = [
      { id: 'empId', label: 'ID' },
      { id: 'firstName', label: 'First Name' },
      { id: 'lastName', label: 'Last Name' },
      { id: 'roleName', label: 'Role' },
      { id: 'email', label: 'Email' },
      { id: 'terminalName', label: 'Terminal' },
      { id: 'vehicleLicensePlate', label: 'Lic. Plate' },
      { id: 'status', label: 'Status' },
      { id: 'clockInTime', label: 'Last Clocked In' },
      { id: 'action', label: '' },
    ]
    const showAddEmployee = canAddEmployee()

    const timecardsInfoSort = sortArrayByName(timecardsInfo || [])
    return (
      <div>
        <Grid container>
          <Grid className="addButton" item xs={12} sm={6} md={6} lg={6}>
            <Typography variant="gutterBottom">
              Employees ({employees.length} of {maxEmployees})
            </Typography>
          </Grid>
          {hasAccess() && showAddEmployee ? (
            <Grid className="addButton" item xs={12} sm={6} md={6} lg={6}>
              <Button
                variant="raised"
                className="primary-button pull-right margin-bottom-small"
                onClick={this.addEmployee}
              >
                Add Employee
              </Button>
            </Grid>
          ) : (
            <Grid className="addButton" item xs={12} sm={12} md={12} lg={12} />
          )}
          {this.state.showClockedIn && (
            <Grid className="addButton margin-bottom-small" item xs={12} sm={12} md={12} lg={12}>
              <Typography variant="gutterBottom">
                EMPLOYEES CLOCKED IN ({timecards.length || 0})
              </Typography>
            </Grid>
          )}
        </Grid>
        {this.state.showClockedIn ? (
          <ListContainer
            columns={timeCardColumns}
            list={timecardsInfoSort}
            actionText={'Clock Out'}
            onClick={this.clockOut}
            onSearch={() => {}}
            term={this.state.term}
            hide={true}
            isSectionEmployees
          />
        ) : (
          <ListContainer
            columns={employeeColumns}
            list={employeeInfo}
            onChangeTerm={this.onChangeTerm}
            actionText={'View'}
            onClick={this.viewEmployee}
            onSearch={this.onSearch}
            term={this.state.term}
            onClickRow={this.viewEmployee}
            isSectionEmployees
          />
        )}
      </div>
    )
  }
}

export default connect((state) => ({
  dispatch: state.dispatch,
  employeeReducer: state.employeeReducer,
  companyReducer: state.companyReducer,
}))(ContainerWithTitle(Employees, 'Employees'))



// WEBPACK FOOTER //
// ./src/containers/Settings/Employees/index.js